import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { COMMON, ONBOARDING } from "../config/apiEndPoint";
import { GET, MULTIPART_POST, POST } from "config/api.config";

export const getOnboardingList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${ONBOARDING.GET_ONBOARDING_LIST}/${data?._Id}`
      : `${ONBOARDING.GET_ONBOARDING_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addOnboarding = async (data = array()) => {
  try {
    const response = await MULTIPART_POST(ONBOARDING.ONBOARDING_UPSERT, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateOnboarding = async (id, data = array()) => {
  try {
    const response = await MULTIPART_POST(ONBOARDING.ONBOARDING_UPSERT, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getOnboardingDataById = async (data = array()) => {
  try {
    const url = data?.Id
      ? `${ONBOARDING.GET_ONBOARDING_LIST}/${data?.Id}`
      : `${ONBOARDING.GET_ONBOARDING_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchOnboardingTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${ONBOARDING.GET_ONBOARDING_SCHEMA}/${data?._Id}`
      : `${ONBOARDING.GET_ONBOARDING_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitOnboardingFilterData = async (data = array()) => {
  try {
    const response = await POST(ONBOARDING.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientListForOnboarding = async (data = array()) => {
  try {
    const response = await POST(ONBOARDING.GET_CLIENT_LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `client/Onboarding/form-schema` — add-form defaults and restart client bag. */
export const fetchOnboardingFormSchema = async () => {
  try {
    const response = await GET(ONBOARDING.FORM_SCHEMA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

const unwrapOnboardingOptionsList = (payload) => {
  const data = payload?.data ?? payload;
  if (Array.isArray(data)) return data;
  const inner = data?.records ?? data?.items ?? data?.data;
  return Array.isArray(inner) ? inner : [];
};

/** Maps onboarding option rows (`{ id, display }`) to react-select options. */
export const mapOnboardingOptionsApiToSelectOptions = (payload) =>
  unwrapOnboardingOptionsList(payload)
    .map((item) => {
      const value = String(item?.id ?? item?.value ?? "").trim();
      const label = String(item?.display ?? item?.label ?? value).trim();
      return value ? { value, label } : null;
    })
    .filter(Boolean);

/** GET `client/Onboarding/options/ad-spend` */
export const fetchOnboardingAdSpendOptions = async () => {
  try {
    const response = await GET(ONBOARDING.OPTIONS_AD_SPEND);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `client/Onboarding/options/indeed-access` */
export const fetchOnboardingIndeedAccessOptions = async () => {
  try {
    const response = await GET(ONBOARDING.OPTIONS_INDEED_ACCESS);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `client/Onboarding/options/safety` */
export const fetchOnboardingSafetyOptions = async () => {
  try {
    const response = await GET(ONBOARDING.OPTIONS_SAFETY);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/account-executive-users` — account owner dropdown options. */
export const fetchOnboardingAccountExecutiveUsers = async () => {
  try {
    const response = await GET(COMMON.ACCOUNT_EXECUTIVE_USERS);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `client/Onboarding/client-prefill/{clientId}` — prefill after restart client select. */
export const fetchOnboardingClientPrefill = async (clientId = "") => {
  const raw = String(clientId ?? "").trim();
  if (!raw) {
    toast.error("Client id is required");
    return undefined;
  }
  try {
    const response = await GET(ONBOARDING.CLIENT_PREFILL(raw));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
